export const MissingValue = () => (
  <span className="text-muted-foreground">—</span>
);
